export default {
    projects: [],
    teammates: [],
    selectedProject: [],
}